/* eslint-disable react/jsx-max-depth */
/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Component } from 'react'

import { search } from '@root/utility'

import Layout   from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import Pagination from '@/Pagination'

import SearchBar from '@Pure/SearchBar'
import Loader    from '@Pure/Loader'
import Image     from '@Pure/Image'
import Link      from '@Pure/Link'

import getErrorsFromResponse from '@function/ajax/getErrors'

const app = window.app;

const qwest = window.qwest;

export default class FrontArtistsPage extends Component
{
	state =
	{
		data: [],

		data_count: 0,

		page: 0,
		items_per_page: 30,

		searched: '',
		searched_city: ''
	};

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, config = this.props.config;

		app.resetFunctions();

		component.fetchData({ });
	}

	fetchData = ({ page }) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState({ loading: true });

		const page_number = typeof page === 'undefined'
		? state.page
		: page;

		qwest.post('/fetch/artists',
		{
			searched_city: state.searched_city,
			searched: state.searched,

			limit: state.items_per_page,
			skip: page_number * state.items_per_page
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				loading: false,
				data: response.artists || [],
				data_count: response.count || 0
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			component.setState({ ...getErrorsFromResponse(response) });

			console.error(error);
		});
	}

	handleSearch = (value, search) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			[search.name]: value || '',

			page: 0
		});

		app.emit('searchChange');

		if (component.timeout)
		{
			window.clearTimeout(component.timeout);
		}

		component.timeout = window.setTimeout(function ()
		{
			component.timeout = undefined;

			component.fetchData({ });
		},
		400);
	}

	handlePageChange = (e, page) =>
	{
		const component = this, props = this.props, state = this.state;

		if (state.loading === true) return;

		component.setState({ page: page });

		component.fetchData({ page: page });
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let loader;

		if (component.state.loading === true)
		{
			loader =
			(
				<Loader className="c-loader"
					bemit={ ['primary', 'bg-light', 'medium', 'Products'] }
				/>
			);
		}

		let artists = state.data.map(function (artist, key)
		{
			let short_description = (artist.description || '').split('<br>').join('');

			short_description = short_description.split('<p></p>').join('');

			short_description =
			(
				<span className="c-rendered-text" dangerouslySetInnerHTML={
					{ __html: app.truncateToLength(short_description, 130, '') } } />
			);

			let img_url = artist.images ? artist.images[0] : null;

			if (img_url)
			{
				img_url = img_url.url;
			}

			if (!img_url)
			{
				img_url = artist.images instanceof Array ? artist.images[0] : null;

				img_url = img_url ? img_url.url : null;
			}

			if (!img_url) img_url = '/images/Logo_Synergies.jpg';

			let output =
			(
				<div className="c-model-preview-item artist o-grid__item u-flex"
					// eslint-disable-next-line react/no-array-index-key
					key={ artist.id + key }>

					<div className="c-model-preview c-model-preview--artist">
						<div className="c-model-preview__thumb">
							<Link className="c-model-preview__thumb-link"
								href={ '/accueil/artistes/' + artist.id }>
								<Image className="c-model-preview__img"
									src={ img_url } />
							</Link>
						</div>

						<h2 className="c-model-preview__title">
							<Link href={ '/accueil/artistes/' + artist.id }
								className="c-model-preview__title-link">
								{ artist.name }
							</Link>
						</h2>

						<div className="c-model-preview__infos">

							<div className="c-model-preview__description">
								{ short_description }
							</div>

							<div className="c-model-preview__buttons">
								<Link href={ '/accueil/artistes/' + artist.id }
									className="c-model-preview__link">
									<svg className="o-svg-icon o-svg-icon--eye c-model-preview__link-icon">
										<use xlinkHref="/images/icons.svg#svg-icon-eye" />
									</svg>
									Fiche artiste
								</Link>
							</div>

						</div>
					</div>

				</div>
			);

			return output;
		});

		const pagination = state.data_count > state.items_per_page &&
			!state.searched && !state.searched_city ?
		(
			<Pagination current={ state.page }
				total={ state.data_count }
				items-per-page={ state.items_per_page }
				onChange={ component.handlePageChange }
			/>
		)
		: undefined;

		return (
			<Layout history={ props.history } hide_title
				page_title="Artistes & festivals">

				<div className="page-content">

					<HolidaysMessage />

					<div className="o-content">

						<div className="c-title u-margin-top-0">
							<h2 className="c-title__txt">Artistes &amp; festivals</h2>
						</div>

						<div className="front-dashboard-search">
							<div className="o-grid-2">
								<div className="o-grid__item">
									<SearchBar className="c-searchbar c-searchbar--front"
										hide_btn data={ [] }
										placeholder="Rechercher dans les artistes"
										handleChange={ component.handleSearch }
										value={ state.searched }
										name="searched"
									/>
								</div>

								<div className="o-grid__item">
									<SearchBar className="c-searchbar c-searchbar--front"
										hide_btn data={ [] }
										placeholder="Rechercher une ville"
										handleChange={ component.handleSearch }
										value={ state.searched_city }
										name="searched_city"
									/>
								</div>
							</div>

						</div>

						{ pagination }

						<div className="u-negative-margin u-margin-top-15">

							<div className="o-grid-6 u-flex">
								{ loader || artists }
							</div>

						</div>

						{ pagination }

					</div>

				</div>

			</Layout>
		);
	}
}